var _defs, _tspan, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "80.202866mm",
    viewBox: "0 0 132.29167 80.202866",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-216.79713)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE1F8\\uE1F3\\uE1F8\\uE1F3",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(0.81825998,0,0,0.81825998,1.6506742e-7,69.230123)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 29.104245,253.70439 c -1.924247,-1.56345 -4.570088,-2.52558 -7.69699,-2.52558 -11.9062818,0 -21.40725409173874,8.77938 -21.40725409173874,18.16009 0,5.65248 4.57008799173874,9.01991 10.46309609173874,9.01991 9.621238,0 21.407254,-9.01991 21.52752,-18.03982 v -79.97654 h -2.886372 z",
    id: "path4294"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 64.428469,180.34245 H 31.47573 V 192.369 h 32.952739 z",
    id: "path4296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 63.89103,180.34245 V 192.369 h 30.066368 v 61.21512 c -1.924247,-1.56345 -4.570088,-2.52557 -7.69699,-2.52557 -11.906282,0 -21.407254,8.77938 -21.407254,18.16008 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.407254,-8.89964 21.52752,-18.03982 v -79.85627 z",
    id: "path4298"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 129.25908,180.34245 H 96.306336 V 192.369 h 32.952744 z",
    id: "path4300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 128.72163,180.34245 V 192.369 H 158.788 v 61.21512 c -1.92424,-1.56345 -4.57009,-2.52557 -7.69699,-2.52557 -11.90628,0 -21.40725,8.77938 -21.40725,18.16008 0,5.65248 4.57009,9.01991 10.46309,9.01991 9.62124,0 21.40726,-8.89964 21.52752,-18.03982 v -79.85627 z",
    id: "path4302"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeee);
export default __webpack_public_path__ + "static/media/ceee.e0a49b9794efca866864e51a5d18fb2d.svg";
export { ForwardRef as ReactComponent };